<template>
    <div>
        <video
               id="videoplay"
               src=""
               loop="loop"
               autoplay="autoplay"
               muted
               width="1"
               height="1"
               poster="../assets/kejiguan.jpeg"
        >
        </video>
<!--      <div  style="width: 100%;height:100%; background-color: red"></div>-->
<!--        <div class='popContainer'>-->
<!--            <div class="rollback" @click="rollback()">-->

<!--            </div>-->
<!--&lt;!&ndash;            <img src="../assets/title.png" alt=""style="width: 100%">&ndash;&gt;-->
<!--            <div class="times">-->
<!--                {{currentTime}}-->
<!--            </div>-->
<!--        </div>-->
        <div class="anniu">
            <el-button class="anniu1" type="text" style="margin-top: 50px;color: white;font-size:50px;" @click="anniu('1')">公司简介</el-button>
<!--            <el-button class="anniu2" type="text" style="margin-top: 50px;color: white;font-size:30px;" @click="anniu('2')" >时光商城</el-button>-->
<!--            <el-button class="anniu3" type="text" style="margin-top: 50px;color: white;font-size:30px;" @click="anniu('3')">细胞总库</el-button>-->
            <el-button class="anniu4" type="text" style="margin-top: 50px;color: white;font-size:50px;" @click="anniu('4')">联系我们</el-button>
        </div>
      <div class='beian' style="width: 50%;height: 50px;top: 98%;left: 30%;font-size: 15px;color: white">
        广州艾科云信息技术有限公司
        广州市南沙区广东医谷五号楼二层
        咨询电话：(020)84529290
        2003-2024 Witness All Rights Reserved.广州艾科云信息技术有限公司
        <el-link type="info" href="https://beian.miit.gov.cn/#/Integrated/index" style="font-size: 15px;color: white">粤ICP备2023123250号-3</el-link>
      </div>

<!--      时光商城二维码-->
      <el-dialog
        title="会员商城---微信扫一扫"
        :visible.sync="shangcheng"
        width="30%"
        :before-close="handleClose">

        <el-image
          style="width: 300px; height: 300px"
          :src="require('@/assets/shangchengma.jpeg')"
          :fit="fill"></el-image>
        <span slot="footer" class="dialog-footer">

  </span>
      </el-dialog>

<!--      联系我们弹框-->
      <el-dialog title="预约|参观|咨询" :visible.sync="dialogFormVisible" style="width: 50%;left: 30%;top: 10%">
        <el-form :model="form">
          <el-form-item label="来访目的" :label-width="formLabelWidth">
            <el-select v-model="form.region" placeholder="请选择来访目的" style="float: left">
              <el-option label="预约参观" value="预约参观"></el-option>
              <el-option label="预防咨询" value="预防咨询"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名" :label-width="formLabelWidth" >
            <el-input v-model="form.name" maxlength="11" autocomplete="off" style="width: 194px;float: left"></el-input>
          </el-form-item>
          <el-form-item label="手机号" :label-width="formLabelWidth">
            <el-input v-model="form.iPhone"  maxlength="11" autocomplete="off" style="width: 194px;float: left"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="hanbutton">确 定</el-button>
        </div>
      </el-dialog>
        <div class="goBack" @click="rollback()">

        </div>
    </div>
</template>

<script>
 import { postkh  } from '@/api/user'

	export default {
		name: "navigation",
		data(){

			return{
				timer: "",
				currentTime: '',
        dialogFormVisible:false,
        shangcheng:false,
        form: {
          name: '',
          iPhone:'',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        formLabelWidth: '100px'
			}
		},
		methods: {
       hanbutton(){
		    console.log(this.form.region)
        console.log(this.form.name)
        console.log(this.form.iPhone)
        if (this.form.region.length > 0 && this.form.name.length > 0 && this.form.iPhone.length > 0){
          this.postadd()
        }
      },
      async postadd(){
        let data = await postkh({name:this.form.name,phone:this.form.iPhone,tag:this.form.region})
        if (data.code == '200'){
          this.dialogFormVisible = false
          this.$message({
            message: '我们已收到您的咨询信息,请您留意电话或微信',
            type: 'success'
          });


        }else {

        }
      },
      handleClose(done) {
        this.shangcheng = false


      },
			anniu(vel){
				if (vel=='1'){this.$router.push('/introduce')}
				if (vel=='2'){
				  // this.$router.push('/stockpile')
          this.shangcheng = true
				}
				if (vel=='3'){this.$router.push('/cell')}
				if (vel=='4'){
				  // this.$router.push('/inquire')
				this.dialogFormVisible = true
				}
            },
			rollback(){
				this.$router.push('/')
            }
        },
		created() {

			var _this = this;
			var times
			_this.timer = setInterval(function() {
				let  shi= new Date().getHours()
				let  fen= new Date().getMinutes()
                shi= shi <= 9 ? "0"+ shi : shi
				fen= fen <= 9 ? "0"+ fen : fen
				times =
					new Date().getFullYear() +
					"-" +
					(new Date().getMonth() + 1) +
					"-" +
					new Date().getDate() +
					" " +
					shi +
					":" +
					fen
				_this.currentTime= times
			}, 1000);
			// console.log(_this.currentTime)
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		}
	}
</script>

<style scoped>
    #videoplay {
        width: 100%;
        height: 100%;
        object-fit: fill;
        border-radius: 5px;
        position: relative;
    }
    .anniu{
        width: 50%;
        height: 200px;
        /*background: crimson;*/
        position: absolute;
        top: 20%;
        left: 25%;
        right: 0;
        bottom: 0;
        /*overflow: hidden;*/
      /*background-color: red;*/
    }
    .goBack{
        width: 20%;
        height: 250px;
        /*background: crimson;*/
        position: absolute;
        top: 76%;
        left: 80%;
        right: 0;
        bottom: 0;
        overflow: hidden;
    }
    .anniu div{
        width: 20%;
        height: 100%;
        /*background: crimson;*/
        float: left;
        margin-left: 4%;
    }
    .beian{
      position: absolute;
      left: 0px;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0);
      width: 100%;
      height: 100px;
      color: cornsilk;
      z-index: 100;
    }
    .popContainer{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0);
        width: 100%;
        height: 100px;
        color: cornsilk;
        z-index: 100;
    }
    .popContainer .rollback{
        width: 150px;
        height: 100px;
        /*background-color: red;*/
        position: absolute;
        top: 10px;
        left: 20px;
        right: 0;
        bottom: 0;
    }
    .popContainer .times{
        height: 20px;
        position: absolute;
        top: 80%;
        left: 80%;
        right: 0;
        bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/navigation.vue